import { useEffect, useRef, useState } from "react";
import { playBeep } from "@/lib/sound";

const BOOT_LINES = [
    "[    0.000000] wikiOS 26.04 LTS (wikidotexe) booting on x86_64",
    "[    0.042131] CPU: 6+ years field experience detected @ full clock",
    "[    0.113289] mounting /dev/experience ......... [ OK ]",
    "[    0.184422] mounting /dev/certificates (7 found) ... [ OK ]",
    "[    0.220441] network-manager: routing 100k+ packets/day",
    "[    0.288510] grafana.service: active — uptime 99.98%",
    "[    0.331502] docker.service: 34+ containers shipped",
    "[    0.402118] loading deployment plates (01-12) .. [ OK ]",
    "[    0.470201] sound-daemon: mechanical clicks armed",
    "[    0.502233] starting display-manager ...",
    "",
    "wikiOS login: wiki (automatic login)",
];

export default function BootSequence({ onDone }) {
    const [lines, setLines] = useState([]);
    const [leaving, setLeaving] = useState(false);
    const finished = useRef(false);

    const finish = () => {
        if (finished.current) return;
        finished.current = true;
        setLeaving(true);
        playBeep(660, 0.08, 0.05, "square");
        setTimeout(onDone, 450);
    };

    useEffect(() => {
        let i = 0;
        const id = setInterval(() => {
            i += 1;
            setLines(BOOT_LINES.slice(0, i));
            if (i >= BOOT_LINES.length) {
                clearInterval(id);
                setTimeout(finish, 650);
            }
        }, 170);
        return () => clearInterval(id);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const skip = () => finish();
        window.addEventListener("keydown", skip);
        return () => window.removeEventListener("keydown", skip);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div
            data-testid="boot-sequence"
            onClick={finish}
            className={`fixed inset-0 z-[100] bg-[#0a0b0e] flex items-center justify-center cursor-pointer transition-opacity duration-500 ${
                leaving ? "opacity-0 pointer-events-none" : "opacity-100"
            }`}
        >
            <div className="boot-flicker w-full max-w-2xl px-6 font-mono text-[13px] leading-relaxed text-neutral-300">
                <div className="flex items-center gap-3 mb-6">
                    <img src="/logo.png" alt="wikidotexe logo" className="w-11 h-11 rounded-lg" />
                    <div>
                        <div className="text-white font-bold tracking-tight">wikiOS 26.04 LTS</div>
                        <div className="text-[10px] uppercase tracking-[0.25em] text-neutral-500">GNU/Linux x86_64</div>
                    </div>
                </div>
                {lines.map((l, i) => (
                    <div key={i} className={l.includes("[ OK ]") ? "text-neutral-300" : l.includes("login") ? "text-white font-bold" : "text-neutral-400"}>
                        {l.includes("[ OK ]") ? (
                            <>
                                {l.replace(" [ OK ]", "")}
                                <span className="text-vermilion font-bold"> [ OK ]</span>
                            </>
                        ) : (
                            l
                        )}
                        {l === "" && "\u00A0"}
                    </div>
                ))}
                <div className="mt-4 flex items-center gap-2 text-neutral-500 text-xs">
                    <span className="w-2 h-4 bg-vermilion cursor-blink" />
                    <span>click or press any key to skip</span>
                </div>
            </div>
        </div>
    );
}
